<template>
    <div :style="`background-color: ${backgroundColor};`">
        <div class="header-inner">
            <div class="header__content">
                <img class="header__logo" :src="img"/>
                <h1 class="header__name">{{name}}</h1>
            </div>
            <slot name="filters"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProjectOverviewHeader",
        props: ['backgroundColor', 'name', 'img']
    }
</script>

<style scoped>

</style>
